import React, { useMemo } from 'react';

const BX = 258;
const BY = 38;

// Partikler i spell'ens farver ved bossens centrum og nærkampens ekstra effekt. Remountes pr. slag (key).
export default function ImpactFx({ spell }) {
  const colors = [spell.color, spell.glow && spell.glow !== 'transparent' ? spell.glow : '#FFFFFF', '#FFFFFF'];
  const count = spell.shake ? 16 : 12;
  const pieces = useMemo(() => Array.from({ length: count }, (_, i) => {
    const angle = (i / count) * Math.PI * 2 + Math.random() * 0.4;
    const dist = 24 + Math.random() * 30;
    return { i, dx: Math.cos(angle) * dist, dy: Math.sin(angle) * dist - 10, rot: (Math.random() * 2 - 1) * 270, color: colors[i % 3] };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [count]);

  return (
    <>
      {pieces.map((p) => (
        <span
          key={p.i}
          style={{ position: 'absolute', left: BX, top: BY, width: 4, height: 4, background: p.color, pointerEvents: 'none', zIndex: 40, '--dx': `${p.dx}px`, '--dy': `${p.dy}px`, '--rot': `${p.rot}deg`, animation: 'zrmConfetti 650ms cubic-bezier(.15,.6,.3,1) forwards' }}
        />
      ))}
      {spell.kind === 'melee' && spell.shape === 'slash' && (
        <div style={{ position: 'absolute', left: BX - 24, top: BY - 1, width: 48, height: 3, background: '#fff', pointerEvents: 'none', zIndex: 40, animation: 'zrmSlash .4s both' }} />
      )}
      {spell.kind === 'melee' && (spell.shape === 'bash' || spell.shape === 'smash') && (
        <div style={{ position: 'absolute', left: BX - 20, top: BY - 20, width: 40, height: 40, borderRadius: '50%', border: `3px solid ${spell.color}`, boxSizing: 'border-box', pointerEvents: 'none', zIndex: 40, animation: 'zrmRingOut .45s ease-out both' }} />
      )}
    </>
  );
}
